// extracted by mini-css-extract-plugin
module.exports = {"regContainer":"Register_regContainer__3_sT8","imgdiv":"Register_imgdiv__2Crpg","btn":"Register_btn__3hjK0"};